/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinksByCustomerAndFideliusToken} from '../api'

 export const useQueryGetInstrumentLinksByCustomerAndFideliusToken = createReactQueryHook('getInstrumentLinksByCustomerAndFideliusToken', getInstrumentLinksByCustomerAndFideliusToken)
